import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import { AdminRuleDetailClient } from '../components/AdminRuleDetailClient'

function AdminRuleDetailError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load system rule.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/admin/rules/$id')({
  head: () => ({
    meta: [{ title: 'System Rule | Unbreakable' }],
  }),
  errorComponent: AdminRuleDetailError,
  component: AdminRuleDetailPage,
})

function AdminRuleDetailPage() {
  const { id } = Route.useParams()
  return <AdminRuleDetailClient id={id} />
}
